import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumGermanBeerDutyMovementType implements BaseEnumType {
  private static allValues: EnumGermanBeerDutyMovementType[] = []; // make sure this is top-most
  
  public static none = new EnumGermanBeerDutyMovementType(0, "None", "enum_german_beer_duty_movement_type_none");
  public static dutiableRemoval = new EnumGermanBeerDutyMovementType(1, "DutiableRemoval", "enum_german_beer_duty_movement_type_dutiable_removal");
  public static dutyReclaimableReturn = new EnumGermanBeerDutyMovementType(2, "DutyReclaimableReturn", "enum_german_beer_duty_movement_type_duty_reclaimable_return");
  public static dutyExemptRemovalForEmployees = new EnumGermanBeerDutyMovementType(4, "DutyExemptRemovalForEmployees", "enum_german_beer_duty_movement_type_duty_exempt_removal_for_employees");
  public static dutySuspendedRemovalStayingInGermany = new EnumGermanBeerDutyMovementType(5, "DutySuspendedRemovalStayingInGermany", "enum_german_beer_duty_movement_type_duty_suspended_removal_staying_in_germany");
  public static dutyExemptRemovalGoingToEU = new EnumGermanBeerDutyMovementType(6, "DutyExemptRemovalGoingToEU", "enum_german_beer_duty_movement_type_duty_exempt_removal_going_to_e_u");
  public static otherDutyExemptRemoval = new EnumGermanBeerDutyMovementType(7, "OtherDutyExemptRemoval", "enum_german_beer_duty_movement_type_other_duty_exempt_removal");
  public static dutyUnpaidReturn = new EnumGermanBeerDutyMovementType(8, "DutyUnpaidReturn", "enum_german_beer_duty_movement_type_duty_unpaid_return");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumGermanBeerDutyMovementType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumGermanBeerDutyMovementType.none; }
  public isDutiableRemoval() { return this === EnumGermanBeerDutyMovementType.dutiableRemoval; }
  public isDutyReclaimableReturn() { return this === EnumGermanBeerDutyMovementType.dutyReclaimableReturn; }
  public isDutyExemptRemovalForEmployees() { return this === EnumGermanBeerDutyMovementType.dutyExemptRemovalForEmployees; }
  public isDutySuspendedRemovalStayingInGermany() { return this === EnumGermanBeerDutyMovementType.dutySuspendedRemovalStayingInGermany; }
  public isDutyExemptRemovalGoingToEU() { return this === EnumGermanBeerDutyMovementType.dutyExemptRemovalGoingToEU; }
  public isOtherDutyExemptRemoval() { return this === EnumGermanBeerDutyMovementType.otherDutyExemptRemoval; }
  public isDutyUnpaidReturn() { return this === EnumGermanBeerDutyMovementType.dutyUnpaidReturn; }

  public static getValues(): readonly EnumGermanBeerDutyMovementType[] {
    return EnumGermanBeerDutyMovementType.allValues;
  }

  public static getValuesExcept0(): readonly EnumGermanBeerDutyMovementType[] {
    return EnumGermanBeerDutyMovementType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumGermanBeerDutyMovementType {
    const found = EnumGermanBeerDutyMovementType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumGermanBeerDutyMovementType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumGermanBeerDutyMovementType): EnumGermanBeerDutyMovementType {
    const found = name ? EnumGermanBeerDutyMovementType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumGermanBeerDutyMovementType - Value not found: ${ name }`);
    }

    return found;
  }
}